import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSportContext } from '../onboarding/sportContext';
import { enableDemoSchool } from './demoApi';

const SPORT_LABEL_KEYS = {
  1: 'demoSportFootball',
  2: 'demoSportSwimming',
  3: 'demoSportHockey',
  4: 'demoSportBoxing',
  5: 'demoSportGymnastics'
};

export default function DemoOfferModal({
  visible,
  sportTypeId,
  onShowDemo,
  onSkip,
  onSuccessClose
}) {
  const { t } = useTranslation(['onboarding']);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const ctx = getSportContext(sportTypeId || 1);
  const sportLabel = t(`onboarding:${SPORT_LABEL_KEYS[sportTypeId] || 'demoSportDefault'}`);

  if (!visible) return null;

  async function handleEnable() {
    setLoading(true);
    try {
      const data = await enableDemoSchool(sportTypeId || 1);
      setResult(data);
    } catch {
      setLoading(false);
    }
    setLoading(false);
  }

  if (result) {
    return (
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>✓</div>
          <h2 style={titleStyle}>{t('onboarding:demoOfferSuccessTitle', { name: result.schoolName })}</h2>
          <p style={textStyle}>
            {t('onboarding:demoOfferSuccessHint')}
          </p>
          <button type="button" style={primaryBtn} onClick={() => onShowDemo(result)}>
            {t('onboarding:demoOfferViewBtn')}
          </button>
          <button type="button" style={ghostBtn} onClick={() => onSuccessClose?.(result)}>
            {t('onboarding:demoOfferSetupBtn')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={overlayStyle}>
      <div style={cardStyle}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>{ctx.sportEmoji}</div>
        <h2 style={titleStyle}>{t('onboarding:demoOfferTitle')}</h2>
        <p style={textStyle}>
          {t('onboarding:demoOfferBody', { sport: sportLabel, students: t('onboarding:students') })}
        </p>
        <p style={{ ...textStyle, marginBottom: 20 }}>
          {t('onboarding:demoOfferSwitchHint')}
        </p>
        <button type="button" style={primaryBtn} onClick={handleEnable} disabled={loading}>
          {loading ? t('onboarding:demoOfferLoading', { sport: sportLabel }) : t('onboarding:demoOfferShowBtn')}
        </button>
        <button type="button" style={ghostBtn} onClick={onSkip} disabled={loading}>
          {t('onboarding:demoOfferSkipBtn')}
        </button>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  zIndex: 20001,
  background: 'rgba(13,13,26,0.92)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24
};

const cardStyle = {
  background: '#fff',
  borderRadius: 16,
  padding: '32px 28px',
  maxWidth: 420,
  width: '100%',
  textAlign: 'center',
  boxShadow: '0 16px 48px rgba(26,35,126,0.2)'
};

const titleStyle = { margin: '0 0 12px', color: '#0d0d1a', fontSize: 20 };
const textStyle = { color: '#616161', lineHeight: 1.55, fontSize: 14, marginBottom: 12 };
const primaryBtn = {
  width: '100%',
  padding: '12px 20px',
  background: '#EB3333',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  fontSize: 15,
  cursor: 'pointer',
  marginBottom: 10
};
const ghostBtn = {
  background: 'none',
  border: 'none',
  color: '#9e9e9e',
  fontSize: 14,
  cursor: 'pointer'
};
